/*
 * Make the store globally accessible
 */
export const getStore = () => window.store;
